import {SOPostProcessStepAssociation} from '../../core/process-step-association/so-post-process-step-association';
import {ProcessStepAssociationCore} from './process-step-association.core';
import {SOGetProcessStepAssociation} from '../../core/process-step-association/so-get-process-step-association';
import {FormField, SelectionOption} from 'lionheartland';
import {postProcessStepAssociationFormFieldOptions} from './post-process-step-association-form-fields';
import {AdapterProtocol} from 'lionheartland';
import {BasePost} from 'lionheartland';
import {ProcessCore} from '../process/process.core';
import {SOGetProcess} from '../../core/process/so-get-process';
import {StepCore} from '../step/step.core';
import {SOGetStep} from '../../core/step/so-get-step';
import {ProjectCore} from '../project/project.core';
import {SOGetProject} from '../../core/project/so-get-project';
import {OrganizationCore} from '../organization/organization.core';
import {SOGetOrganization} from '../../core/organization/so-get-organization';

export class RAPostProcessStepAssociation extends BasePost implements AdapterProtocol {
  formFieldOptions = Object.values(postProcessStepAssociationFormFieldOptions);

  RequestClass = SOPostProcessStepAssociation

  constructor(
    public entityCore: ProcessStepAssociationCore
  ) {
    super();
    if (postProcessStepAssociationFormFieldOptions.process) {
      postProcessStepAssociationFormFieldOptions.process.makeCore = true;
    }
    if (postProcessStepAssociationFormFieldOptions.step) {
      postProcessStepAssociationFormFieldOptions.step.makeCore = true;
    }
    if (postProcessStepAssociationFormFieldOptions.project) {
      postProcessStepAssociationFormFieldOptions.project.makeCore = true;
    }
  }

  onSet() {
    super.onSet()
  }

  prepareRequest() {
    this.request = new this.RequestClass(
      this.getFormValueFromIdentifier('name'),
      this.getFormValueFromIdentifier('processStepType'),
      this.getFormValueFromIdentifier(
        'project',
        SOGetProject,
      ),
      this.getFormValueFromIdentifier(
        'organization',
        SOGetOrganization,
        true,
      ),
      this.getFormValueFromIdentifier(
        'process',
        SOGetProcess,
      ),
      this.getFormValueFromIdentifier(
        'step',
        SOGetStep,
      ),
    )
  }


  onSelectionChange(field: FormField) {
    super.onSelectionChange(field)
  }

  fetchOptions(field: FormField) {
    super.fetchOptions(field)
  }

  getSelectionOption(field: FormField, entity): SelectionOption {
    return super.getSelectionOption(field, entity)
  }
}